var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-inline-flex align-items-center py-1 px-2 font-bold verification-status",class:{
  'finished-status': _vm.status === 'FINISHED',
  'transferred-status': _vm.status === 'TRANSFERRED',
  'pending-status': _vm.status === 'PENDING',
  'canceled-status': _vm.status === 'CANCELED'
}},[_vm._v(_vm._s(_vm.computedTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }